import { Controller } from "remult";

@Controller("group-opportunity-methods")
export class GroupOpportunityMethods {}
